import { render, staticRenderFns } from "./OffersEmptyStateIllustration.vue?vue&type=template&id=500c0368&scoped=true&"
import script from "./OffersEmptyStateIllustration.vue?vue&type=script&lang=js&"
export * from "./OffersEmptyStateIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c0368",
  null
  
)

export default component.exports